import React from 'react'

import SubscriptionDanglingModal from '@/modules/my-account/subscription-dangling-modal/subscription-dangling-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openDanglingSubscriptionModal = () => {

  const getComponent = (onClose) => (
    <SubscriptionDanglingModal
      open
      onClose={onClose}
    />
  )

  renderElement(getComponent)
}

export default openDanglingSubscriptionModal
